import { isConfigEnabled } from '../config/isConfigEnabled';
import { checkConditions } from './index';

/**
 * Returns true when prerequisite fields required for threshold checks are populated.
 */
const arePrerequisiteFieldsReady = (blockState, prerequisiteFields = ['gcmTeam', 'dealValue']) => {
    if (!blockState || !Array.isArray(prerequisiteFields)) {
        return false;
    }

    return prerequisiteFields.every((fieldName) => {
        const value = blockState[fieldName];
        if (value === '' || value == null || value === undefined) {
            return false;
        }

        if (fieldName === 'dealValue' && Number.isNaN(Number(value))) {
            return false;
        }

        return true;
    });
};

/**
 * Returns save-blocking threshold error from block.config.trackerThreshold, or null.
 */
export const getBelowTrackerThresholdError = (blockState, trackerThresholdConfig) => {
    if (!isConfigEnabled(trackerThresholdConfig) || !trackerThresholdConfig?.rules?.length) {
        return null;
    }

    if (!arePrerequisiteFieldsReady(blockState, trackerThresholdConfig.prerequisiteFields)) {
        return null;
    }

    for (const rule of trackerThresholdConfig.rules) {
        if (rule.enable === false) {
            continue;
        }

        if (!Array.isArray(rule.conditions) || !checkConditions(rule.conditions, blockState)) {
            continue;
        }

        if (rule.blockSave !== false) {
            return {
                title: rule.title || 'Below tracker threshold',
                message: rule.message || 'This deal is below the tracking threshold.',
            };
        }
    }

    return null;
};
